'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.PushCartBody = PushCartBody;
exports.setLoading = setLoading;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _themeCart = require('@shopify/theme-cart');

var shopifyCart = _interopRequireWildcard(_themeCart);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _pushCartActions = require('../../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _pushCartTypes = require('../../../store/types/push-cart-types');

var pushCartTypes = _interopRequireWildcard(_pushCartTypes);

var _utils = require('./utils');

var _PushCartItem = require('./PushCartItem');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartBody(_ref) {
  var _this = this;

  var lineItems = _ref.lineItems;

  var dispatch = (0, _reactRedux.useDispatch)();

  var getRandomID = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(randomId) {
      var dataInit, dataInitChildren, index, currentCart, currentChildren;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return shopifyCart.getState();

            case 2:
              dataInit = _context.sent;

              // We count how many children we have to remove
              dataInitChildren = dataInit.items.filter(function (item) {
                return item.properties.__MixAndMatchID === randomId && item.properties.__MixAndMatchChild === true;
              });

              dispatch(setLoading(true));

              // Remove children loop
              index = 0;

            case 6:
              if (!(index < dataInitChildren.length)) {
                _context.next = 16;
                break;
              }

              _context.next = 9;
              return shopifyCart.getState();

            case 9:
              currentCart = _context.sent;
              currentChildren = currentCart.items.filter(function (item) {
                return item.properties.__MixAndMatchID === randomId && item.properties.__MixAndMatchChild === true;
              });

              // And we remove the first/top element of the array

              _context.next = 13;
              return dispatch(pushCartActions.removeLineItemMixMatchSet(currentChildren[0].key));

            case 13:
              index++;
              _context.next = 6;
              break;

            case 16:

              dispatch(setLoading(false));

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function getRandomID(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return _react2.default.createElement('div', { className: 'psh-Body' }, _react2.default.createElement('ul', { className: 'psh-Body_Items' }, lineItems.map(function (lineItem) {
    return !(0, _utils.isLineItemFreeGift)(lineItem) && _react2.default.createElement(_PushCartItem.PushCartItem, { lineItem: lineItem, key: lineItem.key, sendRandomID: getRandomID });
  })), _react2.default.createElement('div', { className: 'psh-Body_Loading' }, _react2.default.createElement('svg', { viewBox: '0 0 44 44', xmlns: 'http://www.w3.org/2000/svg', stroke: '#000' }, _react2.default.createElement('g', { fill: 'none', fillRule: 'evenodd', strokeWidth: '2' }, _react2.default.createElement('circle', { cx: '22', cy: '22', r: '1' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    begin: '0s',
    dur: '1.8s',
    values: '1; 20',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.165, 0.84, 0.44, 1',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'stroke-opacity',
    begin: '0s',
    dur: '1.8s',
    values: '1; 0',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.3, 0.61, 0.355, 1',
    repeatCount: 'indefinite'
  })), _react2.default.createElement('circle', { cx: '22', cy: '22', r: '1' }, _react2.default.createElement('animate', {
    attributeName: 'r',
    begin: '-0.9s',
    dur: '1.8s',
    values: '1; 20',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.165, 0.84, 0.44, 1',
    repeatCount: 'indefinite'
  }), _react2.default.createElement('animate', {
    attributeName: 'stroke-opacity',
    begin: '-0.9s',
    dur: '1.8s',
    values: '1; 0',
    calcMode: 'spline',
    keyTimes: '0; 1',
    keySplines: '0.3, 0.61, 0.355, 1',
    repeatCount: 'indefinite'
  }))))));
}

PushCartBody.propTypes = {
  lineItems: _propTypes2.default.array.isRequired
};

function setLoading(isLoading) {
  return {
    type: pushCartTypes.SET_LOADING,
    payload: isLoading
  };
}